//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            form: new Form({
                oldPassword: null,
                newPassword: null,
                newPassword_confirmation: null
            }),
            loading: false,
            hideFormFields: false,
            hideSuccess: true
        };
    },


    methods: {
        formGroupClass: function formGroupClass(name) {
            return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
        },
        onClick: function onClick() {
            this.loading = true;
            App.event.fire('newPassword.send');
        }
    },

    created: function created() {
        var _this = this;

        App.event.listen('newPassword.send', function () {
            _this.form.post('/profile/user-data/password-change').then(function (response) {
                _this.hideFormFields = true;
                _this.hideSuccess = false;
            }).catch(function (errors) {
                _this.loading = false;
                App.event.fire('newPassword.failed', errors);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/password-change/components/PasswordChange.vue
// module id = Rn6h
// module chunks = 4